import React from 'react';
import {useAuth} from "../contexts/AuthContext";
import LoadingSpinner from "../components/common/LoadingSpinner";
import {Navigate, Outlet} from "react-router-dom";
import {RoutePaths} from "../config/routeConstants";

const LicenseRoleGuard = ({ allow }: { allow: 'admin' | 'user' }) => {
    const {isAdmin, isVerifying} = useAuth();

    if (isVerifying) return <LoadingSpinner/>;

    const allowed = allow === 'admin' ? isAdmin : !isAdmin ;

    if (!allowed) {
        return <Navigate to={isAdmin ? RoutePaths.LicenseActivation : RoutePaths.LicensePending} replace />;
    }

    return <Outlet />;
};

export default LicenseRoleGuard;